const cases = [
  { icon: "ri-archive-line", label: "Warehouse & inventory systems" },
  { icon: "ri-building-2-line", label: "Multi-location business control" },
  { icon: "ri-shopping-cart-line", label: "Custom order management platforms" },
  { icon: "ri-user-follow-line", label: "Workforce and productivity tracking" },
  { icon: "ri-dashboard-3-line", label: "Internal dashboards and reporting tools" },
];

export default function UseCases() {
  return (
    <section className="py-12 md:py-16 bg-graphite-850">
      <div className="w-full px-4 sm:px-6 lg:px-8 xl:px-16">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-2xl sm:text-3xl font-bold text-white mb-3">Use Cases</h2>
          <p className="text-base text-silver-300 mb-8 max-w-2xl">
            Real-world scenarios where bespoke solutions drive measurable impact.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {cases.map((c) => (
              <div key={c.label} className="glass-card p-5 flex items-center gap-3 group">
                <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-graphite-800 group-hover:bg-emerald-accent/10 transition-colors flex-shrink-0">
                  <i className={`${c.icon} text-emerald-accent group-hover:scale-110 transition-transform duration-300`} />
                </div>
                <span className="text-sm font-medium text-white group-hover:text-emerald-soft transition-colors duration-300">{c.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}